import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menuDocument",
  "use": "icon-menuDocument-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-menuDocument\">\n<path d=\"M15 2.25L16.5 5.25V15C16.5 15.1989 16.421 15.3897 16.2803 15.5303C16.1397 15.671 15.9489 15.75 15.75 15.75H2.25C2.05109 15.75 1.86032 15.671 1.71967 15.5303C1.57902 15.3897 1.5 15.1989 1.5 15V5.253L3 2.25H15ZM9 7.5L6 10.5H8.25V13.5H9.75V10.5H12L9 7.5ZM14.073 3.75H3.927L3.17775 5.25H14.823L14.073 3.75Z\" fill=\"#334681\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/menuDocument.svg
// module id = CMCD
// module chunks = 111